import axios from "axios";
import { baseURL } from "@/services/baseURL.js";
import Store from "@/store";

const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    accept: "application/json",
    "content-type": "application/json",
  },
  withCredentials: false,
});

export default {
  loginPengguna(Pengguna) {
    return apiClient.post("/login/login.php", Pengguna);
  },
  login(Pengguna) {
    return apiClient.post("/test.php", Pengguna);
  },
  loginPublic(requestData) {
    return axios.post(`${baseURL}/login_public.php`, requestData);
  },
  registerPublic(registrationData) {
    return axios.post(`${baseURL}/register_public.php`, {
      request: registrationData,
    });
  },
  checkHRMIS(icNumber) {
    const requestData = {
      request: {
        userId: icNumber,
      },
    };
    return axios.post(`${baseURL}/check_hrmis.php`, requestData);
  },
  checkuser(icNumber) {
    const requestData = {
      request: {
        userId: icNumber,
      },
    };
    return axios.post(`${baseURL}/check_user.php`, requestData);
  },
  forgotPassword(requestData) {
    return axios.post(`${baseURL}/forgot_password.php`, {
      request: requestData,
    });
  },
  resetPassword(data) {
    return axios.post(`${baseURL}/reset_password_public.php`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  checkPasswordHistory(data) {
    return axios.post(`${baseURL}/check-password-history.php`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
  getDashboard(search) {
    return apiClient.get("/pemanggil/dashboard.php", { params: search });
  },
  getPenggunaInfo(currentPage) {
    return apiClient.get(
      "/api/pengguna/senarai_pengguna_info.php?currentPage=" + currentPage
    );
  },
  getPenggunaData(currentPage) {
    return apiClient.get(
      "/api/pengguna/senarai_pengguna_data.php?currentPage=" + currentPage
    );
  },
  getPenggunaInfoParam(Search) {
    return apiClient.get("/api/pengguna/senarai_pengguna_info.php", {
      params: Search,
    });
  },
  getPenggunaDataParam(Search) {
    return apiClient.get("/api/pengguna/senarai_pengguna_data.php", {
      params: Search,
    });
  },
  setKemaskiniPengguna(Pengguna) {
    return apiClient.post("/api/pengguna/kemaskini_pengguna.php", Pengguna);
  },
  testLogin(Search) {
    // console.log("dalam test login service ");
    return apiClient.post("/login/sessionStatus.php", Search);
  },
  loadSession(QueryObj) {
    return apiClient.get("/login/loadSession.php", { params: QueryObj });
  },
  ev_logout() {
    return apiClient.get("/login/ev_logout.php");
  },
  getPeranan(roleId) {
    if ((roleId > 0) & (roleId <= perananLabel.length)) {
      return perananLabel[roleId];
    } else {
      return "Tiada Peranan!";
    }
  },
  registerPengguna(Pengguna) {
    return apiClient.post("/login/register.php", Pengguna);
  },
};
